<template>
		<md-card>
				<md-card-header class="md-card-header-text md-card-header-green">
						<div class="card-text">
								<h4 class="title">{{ this.reward.id ? 'Update' : 'Create' }} Rewards</h4>
						</div>
				</md-card-header>
				<form class="form-horizontal" action="" method="post" v-on:submit.prevent="onSubmit">
						<div class="md-layout">
								<div class="md-layout-item md-size-50 md-small-size-100">
										<div class="md-layout">
												<div class="md-layout-item">
														<md-field>
																<label>Title</label>
																<md-input v-model="reward.title" type="text" required></md-input>
														</md-field>
												</div>
										</div>
										<div class="md-layout">
												<div class="md-layout-item">
														<md-field>
															<md-icon v-show='reward.reward_type == "dollar"'>attach_money</md-icon>
															<label>Value</label>
															<md-input v-model="reward.value" type="value"></md-input>
															<span class="md-suffix" v-show='reward.reward_type == "percentage"'>%</span>
														</md-field>
												</div>
										</div>
										<div class="md-layout">
												<div class="md-layout-item">
														<md-field>
																<label>Cap</label>
																<md-input v-model="reward.cap" type="number"></md-input>
														</md-field>
												</div>
										</div>
										<div class="md-layout-item md-small-size-100">
												<md-card-content class="for-line-item">
														<md-datepicker v-model="reward.start_date" md-immediately class="md-size-50 md-small-size-100">
																<label>Start date</label>
														</md-datepicker>
														<md-datepicker v-model="reward.end_date" md-immediately class="md-size-50 md-small-size-100">
																<label>End date</label>
														</md-datepicker>
												</md-card-content>
										</div>
								</div>
								<div class="md-layout-item md-size-50 md-small-size-100">
										<div class="md-layout-item">
												<md-field>
														<label>Type</label>
														<md-select v-model="reward.reward_type">
																<md-option value="dollar">Dollar</md-option>
																<md-option value="item">Item</md-option>
																<md-option value="percentage">Percentage</md-option>
														</md-select>
												</md-field>
										</div>
										<div class="md-layout-item">
												<md-field>
														<label>Reward Level</label>
														<md-select v-model="reward.reward_level">
																<md-option value="item">Item</md-option>
																<md-option value="cart">Cart</md-option>
																<md-option value="wallet">Wallet</md-option>
														</md-select>
												</md-field>
										</div>
										<div v-if="reward.code" class="md-layout-item">
												<md-field>
														<label>Code</label>
														<md-input v-model="reward.code" type="string"></md-input>
												</md-field>
										</div>
										<div class="md-layout">
												<md-switch v-model="reward.enabled">Enabled</md-switch>
												<md-switch v-model="reward.code_required">Code Required</md-switch>
										</div>
								</div>
						</div>
						<md-card-actions md-alignment="left">
								<md-button class="md-success" type="submit">{{ this.reward.id ? 'Update' : 'Create' }}</md-button>
						</md-card-actions>
				</form>
		</md-card>
</template>

<script>
import moment from "moment"
export default {
	name: "Reward",
	computed: {},
	methods: {
		onSubmit() {
			this.reward.start_date = moment.utc(this.reward.start_date).startOf('day')
			this.reward.end_date = moment.utc(this.reward.end_date).endOf('day')
				
			const newObj = { ...this.reward };
			if (newObj.id) {
				this.$http.secured.put(`/v1/rewards/${newObj.id}`, newObj).then(() => {
					this.$router.push("/rewards")
				})
				.catch(error =>{ alert(JSON.stringify(error.response.data)) });
			} else {
					this.$http.secured
							.post(`/v1/rewards`, newObj)
							.then(() => { this.$router.push('/rewards') })
							.catch(response =>{ alert(response) })
			}
		},
	},
	created() {},
	mounted() {
		if (this.$route.params.id) {
			this.$http.secured
				.get(`/v1/rewards/${this.$route.params.id}`)
				.then(response => {
					this.reward = response.data;
			});
		}
	},

	data() {
		return {
			 reward: {
			 	enabled: false,
			 	code_required: false,
			 	reward_type: "dollar",
			 	reward_level: 0
			 },
				isDisabled: true,
		};
	}
};
</script>
<style>
		.for-line-item {
				display: flex;
		}
</style>